import { Dispatch } from "react";

import { VerifyContractStepFunc } from "../../types";

import { shouldHaveOwnershipTransfer } from "./rules/shouldHaveOwnershipTransfer";
import { shouldHavePaymentMethod } from "./rules/shouldHavePaymentMethod";

import {
  OperationStep,
  AccountStep,
  ItemsStep,
  PaymentMethodStep,
  ConfirmationStep,
  OwnershipTransferStep
} from "@/components/Contracts";
import { Contract } from "@/components/Contracts/contract.interface";
import { IMessageBar } from "@/core/libs/message-bar";

interface IStepComponent {
  contract: Contract;
  nextStep: (contract: Contract, step?: number) => Promise<void>;
  setContract: (contract: Contract) => void;
  verifyContractSteps: ({
    currentContract,
    updateCurrentStep
  }: VerifyContractStepFunc) => void;
  setContractMessage: Dispatch<React.SetStateAction<IMessageBar>>;
  refetchContractData: () => Promise<void>;
  monthlyPaymentMethod: string;
  generateContractTerms: boolean;
  setGenerateContractTerms: (value: boolean) => void;
}

export interface ContractStep {
  name: ContractStepsNames;
  label: string;
  component: React.FC<IStepComponent>;
}

export enum ContractStepsNames {
  DADOS_BASE = "DADOS_BASE",
  COOPERADO = "COOPERADO",
  BENEFICIOS = "BENEFICIOS",
  METODO_DE_PAGAMENTO = "METODO_DE_PAGAMENTO",
  CONFIRMACAO = "CONFIRMACAO",
  DOCUMENTOS_COMPLEMENTARES = "DOCUMENTOS_COMPLEMENTARES"
}

export const getContractSteps = (contract: Contract): ContractStep[] => {
  if (!contract) {
    return [];
  }

  const steps: ContractStep[] = [
    {
      name: ContractStepsNames.DADOS_BASE,
      label: "Dados Base",
      component: OperationStep
    },
    {
      name: ContractStepsNames.COOPERADO,
      label: "Cooperado",
      component: AccountStep
    },
    {
      name: ContractStepsNames.BENEFICIOS,
      label: "Benefícios Combos",
      component: ItemsStep
    }
  ];

  const contractHasOwnershipTransfer = shouldHaveOwnershipTransfer(contract);

  if (contractHasOwnershipTransfer) {
    steps.push({
      name: ContractStepsNames.DOCUMENTOS_COMPLEMENTARES,
      label: "Documentos Complementares",
      component: OwnershipTransferStep
    });
  }

  const contractShouldHavePaymentMethod = shouldHavePaymentMethod(contract);

  if (contractShouldHavePaymentMethod) {
    steps.push({
      name: ContractStepsNames.METODO_DE_PAGAMENTO,
      label: "Método de Pagamento",
      component: PaymentMethodStep
    });
  }

  steps.push({
    name: ContractStepsNames.CONFIRMACAO,
    label: "Confirmação",
    component: ConfirmationStep
  });

  return steps;
};
